import React from "react"
import {Spinner} from "@chakra-ui/react"

function Loading() {

    return <div className="w-full flex flex-col justify-center items-center bg-white mx-auto py-10">
        <Spinner/>
    </div>
}

export {Loading}